import { useTranslation } from "react-i18next";
import type { CommentsLabels } from "@/domain/types/commentsLabels";
export function useCommentsLabels(): CommentsLabels {
  const { t } = useTranslation();
  return {
    title: t("comments.title"),
    thread: t("comments.thread"),
    back: t("comments.back"),
    close: t("comments.close"),
    filter: t("comments.filter"),
    filter_active: t("comments.filter_active"),
    state: t("comments.state"),
    open: t("comments.open"),
    resolved: t("comments.resolved"),
    scope: t("comments.scope"),
    all: t("comments.all"),
    page: t("comments.page"),
    resolve: t("comments.resolve"),
    reopen: t("comments.reopen"),
    actions: t("comments.actions"),
    copy_link: t("comments.copy_link"),
    mute: t("comments.mute"),
    unmute: t("comments.unmute"),
    delete: t("comments.delete"),
    delete_title: t("comments.delete_title"),
    delete_description: t("comments.delete_description"),
    empty_open: t("comments.empty_open"),
    empty_resolved: t("comments.empty_resolved"),
    new_thread: t("comments.new_thread"),
    comment: t("comments.comment"),
    reply: t("comments.reply"),
    reply_placeholder: t("comments.reply_placeholder"),
    new_placeholder: t("comments.new_placeholder"),
    deleted: t("comments.deleted"),
    edited: t("comments.edited"),
    thread_resolved: t("comments.thread_resolved"),
    loading: t("comments.loading"),
    error: t("comments.error"),
    retry: t("comments.retry"),
    mention: t("comments.mention"),
    emoji: t("comments.emoji"),
    reaction: t("comments.reaction"),
    message_actions: t("comments.message_actions"),
    edit: t("comments.edit"),
    edit_field: t("comments.edit_field"),
    edit_hint: t("comments.edit_hint"),
    message_delete_title: t("comments.message_delete_title"),
    message_delete_description: t("comments.message_delete_description"),
    message_deleted: t("comments.message_deleted"),
    link_copied: t("comments.link_copied"),
    unknown_author: t("comments.unknown_author"),
    unread: t("comments.unread"),
    mention_empty: t("comments.mention_empty"),
    mention_title: t("comments.mention_title"),
    cancel: t("comments.cancel"),
    replies: (count) => t("comments.replies", { count }),
    openRecord: (name) => t("comments.open_record", { name }),
    insertEmoji: (emoji) => t("comments.insert_emoji", { emoji }),
  };
}
